// @flow
import React from 'react';
import styled from 'styled-components';
import { colors, typoGraphy } from '../../../stylesheets';
import { setLineHeight } from './setLineHeight';
import { setTextColor } from './setTextColor';
import { setTextTypography } from './setTextTypography';

type Props = {
  type?: string,
  size: 'xl' | 'lg' | 'mdb' | 'md' | 'sm' | 'xs',
  children?: String,
  bold?: Boolean,
  color?:
    | 'black'
    | 'gray'
    | 'lightGray'
    | 'disabled'
    | 'white'
    | 'primary'
    | 'secondary',
  direction: String,
  animation?: Boolean,
  lineHeight?: String,
  opacity?: String,
  breakWord?: Boolean,
  italic?: Boolean,
  height?: String,
  hoverColor?: String,
  useDirection?: Boolean,
  className?: String,
};

Text.defaultProps = {
  type: 'span',
};

function TextElement(props: Props) {
  return React.createElement(props.type, { ...props });
}

const StyledTextComponent = styled(TextElement)((props) => ({
  fontFamily: 'IRANSans',
  margin: '8px 0',
  color: colors[props.color],
  ...typoGraphy[props.size],
  ...setTextColor(props),
  ...setTextTypography(props),
  margin: 0,
  ...(props.bold ? { fontWeight: 'bold' } : {}),
  transition: props.animation ? 'all .3s' : 'none',
  ...setLineHeight(props),
  ...(props.opacity ? { opacity: props.opacity } : {}),
  ...(props.breakWord ? { wordWrap: 'break-word' } : {}),
  ...(props.italic ? { fontStyle: 'italic' } : {}),
  ...(props.height ? { height: props.height } : {}),
  '&:hover': {
    transition: 'all 0.3s',
    ...(props.hoverColor ? { color: colors[props.hoverColor] } : {}),
  },
}));

export default function Text(props: Props) {
  return <StyledTextComponent {...props} />;
}
